<div class="breadcrumb">
  <div class="d-flex justify-content-between align-items-end w-100">
    <div class="d-flex flex-column gap-1">
      @if (breadcrumbProps.preTitle) {
      <h4 class="breadcrumb-event-type">{{ breadcrumbProps.preTitle }}</h4>
      }
      <h4 class="breadcrumb-title">{{ breadcrumbProps.title }}</h4>
    </div>
    @if (breadcrumbProps.eventDetailButtons) {
    <div class="d-flex align-items-center gap-2">
      <!--<app-invite-person [token]="breadcrumbProps.token"></app-invite-person>-->
      <app-add-customer></app-add-customer>
      <app-activate-coupon></app-activate-coupon>
      <app-upload-csv *ngIf="isAdmin"></app-upload-csv>
    </div>
    }
  </div>
</div>
